import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@/assets/gs.css'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-214128175-1',
  autoTracking: {
    screenview: true
  }
})

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLightbulb, faPlus, faMinus, faHome
  //faCaretDown,faExclamationCircle, faAngleLeft, faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faLightbulb, faPlus, faMinus, faHome);

Vue.component('vue-fontawesome', FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: ""
    }
  }
})



Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

